import { fromJS, Iterable as ImmutableIterable, Record as ImmutableRecord } from 'immutable';
const checkIsRoutingRule = options => ImmutableIterable.isIterable(options) && ImmutableIterable.isKeyed(options);
const setShouldFilterToAvailable = options => options.update('shouldFilterToAvailable', shouldFilterToAvailable => typeof shouldFilterToAvailable === 'boolean' ? shouldFilterToAvailable : true);

// Taking this approach from: https://github.com/facebook/immutable-js/issues/334#issuecomment-226097016
const RoutingRuleBase = (defaultValues, name) => {
  const realDefaults = Object.assign({}, defaultValues, {
    shouldFilterToAvailable: true
  });
  return class RoutingRuleBaseFactory extends ImmutableRecord(realDefaults, name) {
    constructor(options) {
      let finalOptions;
      if (checkIsRoutingRule(options)) {
        finalOptions = setShouldFilterToAvailable(options);
      } else if (options) {
        finalOptions = setShouldFilterToAvailable(fromJS(options));
      }
      super(finalOptions);
    }
  };
};
export default RoutingRuleBase;